<template>
  <v-app>
    <v-container grid-list-md>
      <HealthHistoryForm v-if='form' :formType='formType' />
    </v-container>
  </v-app>
</template>

<script>
import HealthHistoryForm from '../components/questionnaire/HealthHistoryForm'
export default {
  components : {
    HealthHistoryForm
  },
  data(){
    return{
      form : null,
      formType : null,
      cformType : null
    }
  },
  mounted(){
    this.form =true
    this.formType = this.$route.params.formType
  },
  watch : {
    formType : function(){
      this.formType === "provider" ? this.cformType = "Provider Form" : this.cformType = "Patient Form"
      this.items = [
        {
          text: 'Home',
          disabled: false,
          to: '/home'
        },
        {
          text: 'Family History',
          disabled: false,
          to: '/familyHistory'
        },
        {
          text: this.cformType,
          disabled: true,
        }
      ]
    }
  }
}
</script>

<style>

</style>
